/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from '@/shared/api/axios-client'
import type {
  GetStatsByDriversOverviewQueryResponse,
  GetStatsByDriversOverviewQueryParams,
  GetStatsByDriversOverview400,
} from '../entities/GetStatsByDriversOverview'
import type { RequestConfig, ResponseErrorConfig } from '@/shared/api/axios-client'
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query'
import { getStatsByDriversOverview } from '../api/getStatsByDriversOverview'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getStatsByDriversOverviewQueryKey = (params?: GetStatsByDriversOverviewQueryParams) =>
  [{ url: '/stats/by-drivers/overview' }, ...(params ? [params] : [])] as const

export type GetStatsByDriversOverviewQueryKey = ReturnType<typeof getStatsByDriversOverviewQueryKey>

export function getStatsByDriversOverviewQueryOptions(
  params?: GetStatsByDriversOverviewQueryParams,
  config: Partial<RequestConfig> & { client?: typeof client } = {},
) {
  const queryKey = getStatsByDriversOverviewQueryKey(params)
  return queryOptions<
    GetStatsByDriversOverviewQueryResponse,
    ResponseErrorConfig<GetStatsByDriversOverview400>,
    GetStatsByDriversOverviewQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal
      return getStatsByDriversOverview(params, config)
    },
  })
}

/**
 * @description Get stats by drivers overview
 * @summary Get stats by drivers overview
 * {@link /stats/by-drivers/overview}
 */
export function useGetStatsByDriversOverview<
  TData = GetStatsByDriversOverviewQueryResponse,
  TQueryData = GetStatsByDriversOverviewQueryResponse,
  TQueryKey extends QueryKey = GetStatsByDriversOverviewQueryKey,
>(
  params?: GetStatsByDriversOverviewQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<GetStatsByDriversOverviewQueryResponse, ResponseErrorConfig<GetStatsByDriversOverview400>, TData, TQueryData, TQueryKey>
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof client }
  } = {},
) {
  const { query: { client: queryClient, ...queryOptions } = {}, client: config = {} } = options ?? {}
  const queryKey = queryOptions?.queryKey ?? getStatsByDriversOverviewQueryKey(params)

  const query = useQuery(
    {
      ...(getStatsByDriversOverviewQueryOptions(params, config) as unknown as QueryObserverOptions),
      queryKey,
      ...(queryOptions as unknown as Omit<QueryObserverOptions, 'queryKey'>),
    },
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<GetStatsByDriversOverview400>> & { queryKey: TQueryKey }

  query.queryKey = queryKey as TQueryKey

  return query
}